module.exports = __webpack_public_path__ + "static/media/service-maintenance.ec7d0ef2.svg";